import React from "react";
import { BarChartPlaceholder } from "./BarChartPlaceholder";

export const BarChartsPlaceholder = () => {
  return (
    <>
      <BarChartPlaceholder title="Income Statement" />
      <BarChartPlaceholder title="Annual" />
      <BarChartPlaceholder title="Balance Sheet" />
    </>
  );
};
